import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appFileDrop]'
})
export class FileDropDirective {
  @Output() public fileOver = new EventEmitter<boolean>();
  @Output() public fileDrop = new EventEmitter<File>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent): void {
    if (!this.haveFiles(event.dataTransfer)) {
      return;
    }

    event.dataTransfer.dropEffect = 'copy';
    event.preventDefault();
    this.emitFileOver(true);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: DragEvent): void {
    if (event.currentTarget === this.elementRef[0]) {
      return;
    }

    event.preventDefault();
    this.emitFileOver(false);
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent): void {
    if (!event.dataTransfer) {
      return;
    }

    event.preventDefault();
    this.emitFileOver(false);
    this.emitFileDrop(event.dataTransfer.files[0]);
  }

  private emitFileOver(isOver: boolean): void {
    this.fileOver.emit(isOver);
  }

  private emitFileDrop(file: File): void {
    this.fileDrop.emit(file);
  }

  private haveFiles(dataTransfer: DataTransfer): boolean {
    return dataTransfer.types.indexOf('Files') !== -1;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/file-drop.directive.ts